module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowThin.0cf3bba.woff";